import { Component } from '@angular/core';
import { ClientService } from '../services/client.service';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ProjectService } from '../services/project.service';
import { ColDef } from 'ag-grid-community';
import { CommonModule } from '@angular/common';
import { PrimeNgModule } from '../shared/prime-ng.module';
import { RouterModule } from '@angular/router';
import { APIUrl } from '../constant/api-call';
import _ from 'underscore';

@Component({
  selector: 'app-master-creation',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PrimeNgModule, RouterModule],
  templateUrl: './master-creation.component.html',
  styleUrl: './master-creation.component.css',
})
export class MasterCreationComponent {
  public masterForm: FormGroup;
  public commonDataObject: any = {
    APIObj: APIUrl,
    selectedMaster: null,
    issuccessAlert: false,
    iserrorAlert: false,
    apiMeassge: '',
    displayDialog: false,
    deleteDialog: false,
    showNoDataImage: false
  }

  constructor(
    private fb: FormBuilder,
    private clientService: ClientService,
    public projectService: ProjectService
  ) {
    this.masterForm = this.fb.group({
      master_type_name: [null, Validators.required],
      master_value_id: [null],
      master_value_name: ['', Validators.required],
      is_active: [true],
      is_remark: [false],
      sub_master_values_details: this.fb.array([])
    });
  }

  public rowData: any[] = [];
  public expandedTypeState: { [key: string]: boolean } = {};
  public expandedMasterState: { [key: number]: boolean } = {};
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1
  };
  public columnDefs: ColDef[] = [
    {
      headerName: 'Sr. No.',
      flex: 0.5,
      cellRenderer: (params: any) =>
        params.data.rowType === 'MASTER' ? params.data.srNo + '.' : ''
    },
    {
      headerName: 'Master Type',
      flex: 1.5,
      cellRenderer: (params: any) => {
        if (params.data.rowType === 'TYPE') {
          const type = params.data.masterTypeName;
          const isExpanded = this.expandedTypeState[type];
          const icon = isExpanded
            ? '<i class="fa fa-chevron-down me-2 toggle-icon"></i>'
            : '<i class="fa fa-chevron-right me-2 toggle-icon"></i>';
          return `
        <span class="toggle-btn" style="cursor:pointer">
          ${icon}
          <strong>${type}</strong>
        </span>
      `;
        }
        return '';
      },
      onCellClicked: (params: any) => {
        if (params.data.rowType === 'TYPE') {
          const type = params.data.masterTypeName;
          this.expandedTypeState[type] = !this.expandedTypeState[type];
          this.rowData = this.getGroupedMasterList(
            this.projectService.getMasterList()
          );
        }
      }
    },
    {
      headerName: 'Master / Sub Master',
      flex: 3,
      cellRenderer: (params: any) => {
        if (params.data.rowType === 'MASTER') {
          const hasSub = params.data.hasSub;
          const id = params.data.masterId;
          const expanded = this.expandedMasterState[id];
          let icon = '';
          if (hasSub) {
            icon = expanded
              ? `<i class="fa fa-chevron-down toggle-master me-2"></i>`
              : `<i class="fa fa-chevron-right toggle-master me-2"></i>`;
          }
          return `
          <span class="toggle-btn" style="cursor:pointer">
            ${icon}
            ${params.data.displayName}
          </span>`;
        }
        if (params.data.rowType === 'SUB') {
          return `<span style="padding-left:40px;cursor:pointer">${params.data.displayName}</span>`;
        }
        return '';
      },
      onCellClicked: (params: any) => {
        const data = params.data;
        const target = params.event.target as HTMLElement;
        if (data.rowType === 'TYPE' && target.classList.contains('toggle-type')) {
          const type = data.masterTypeName;
          this.expandedTypeState[type] = !this.expandedTypeState[type];
          this.rowData = this.getGroupedMasterList(
            this.projectService.getMasterList()
          );
        }
        if (data.rowType === 'MASTER' && target.classList.contains('toggle-master')) {
          const id = data.masterId;
          this.expandedMasterState[id] = !this.expandedMasterState[id];
          this.rowData = this.getGroupedMasterList(
            this.projectService.getMasterList()
          );
        }
      }
    },
    {
      headerName: 'Status',
      flex: 1,
      cellRenderer: (params: any) => {
        if (params.data.rowType === 'MASTER') {
          return params.data.originalData.is_active ? 'Active' : 'Inactive';
        }
        if (params.data.rowType === 'SUB') {
          return params.data.is_active ? 'Active' : 'Inactive';
        }
        return '';
      }
    },
    {
      headerName: 'Actions',
      flex: 1,
      cellRenderer: (params: any) => {
        if (params.data.rowType !== 'MASTER') return '';
        return `<i class="fa fa-edit text-primary me-2 edit-btn" style="cursor:pointer"></i>
        <i class="fa fa-trash text-danger delete-btn" style="cursor:pointer"></i>`;
      },
      onCellClicked: (params: any) => {
        if (params.data.rowType !== 'MASTER') return;
        const target = params.event.target as HTMLElement;
        if (target.classList.contains('edit-btn')) {
          this.editMasterDetails(params.data.originalData);
        }
        if (target.classList.contains('delete-btn')) {
          this.commonDataObject.selectedMaster = params.data.originalData;
          this.commonDataObject.deleteDialog = true;
        }
      }
    }
  ];
  public gridApi: any;

  ngOnInit() {
    this.getRowData();
  }

  onGridReady(params: any) {
    this.gridApi = params.api;

    window.addEventListener('resize', () => {
      this.gridApi.sizeColumnsToFit();
    });
  }

  onFirstDataRendered(params: any) {
    params.api.sizeColumnsToFit();
  }

  getRowData() {
    this.projectService.getMasterData();
    setTimeout(() => {
      this.rowData = this.getGroupedMasterList(this.projectService.getMasterList());
      if (this.rowData?.length === 0) {
        this.commonDataObject.showNoDataImage = true;
      }
    }, 500);
  }


  getGroupedMasterList(apiData: any[]) {
    const rows: any[] = [];
    let srNo = 1;
    const groupedByType = apiData?.reduce((acc, item) => {
      acc[item.master_type_name] = acc[item.master_type_name] || [];
      acc[item.master_type_name].push(item);
      return acc;
    }, {});
    if (!groupedByType) return rows;
    Object.keys(groupedByType).forEach(typeName => {
      if (this.expandedTypeState[typeName] === undefined) {
        this.expandedTypeState[typeName] = true;
      }
      rows.push({
        rowType: 'TYPE',
        masterTypeName: typeName
      });
      if (!this.expandedTypeState[typeName]) return;
      groupedByType[typeName].forEach((master: any) => {
        if (this.expandedMasterState[master.master_value_id] === undefined) {
          this.expandedMasterState[master.master_value_id] = true;
        }
        rows.push({
          rowType: 'MASTER',
          srNo: srNo++,
          displayName: master.master_value_name,
          originalData: master,
          is_active: master.is_active,
          masterId: master.master_value_id,
          hasSub: master.sub_master_values_details?.length > 0
        });
        if (
          master.sub_master_values_details &&
          this.expandedMasterState[master.master_value_id]
        ) {
          master.sub_master_values_details.forEach((sub: any) => {
            rows.push({
              rowType: 'SUB',
              displayName: sub.sub_master_value_name,
              is_active: sub.is_active,
              parentMasterId: master.master_value_id
            });
          });
        }
      });
    });
    return rows;
  }

  addMaster() {
    this.commonDataObject.displayDialog = true;
    this.masterForm.reset({
      master_type_name: null,
      master_value_name: '',
      is_active: true,
      is_remark: false
    });
    this.subMasters.clear();
  }

  get subMasters(): FormArray {
    return this.masterForm.get('sub_master_values_details') as FormArray;
  }

  createSubMaster(data?: any): FormGroup {
    return this.fb.group({
      sub_master_value_id: [data?.sub_master_value_id ?? null],
      sub_master_value_name: [data?.sub_master_value_name ?? '', Validators.required],
      is_active: [data?.is_active ?? true]
    });
  }

  removeSubMaster(index: number) {
    this.subMasters.removeAt(index);
  }

  addSubMaster() {
    this.subMasters.push(this.createSubMaster());
  }

  editMasterDetails(rowData: any) {
    this.commonDataObject.displayDialog = true;
    this.masterForm.reset();
    this.subMasters.clear();
    this.masterForm.patchValue({
      master_type_name: this.projectService.getMasterTypes()
        .find((x: any) => x.master_type_id === rowData?.master_type_id),
      master_value_name: rowData?.master_value_name,
      master_value_id: rowData?.master_value_id,
      is_active: rowData?.is_active,
      is_remark: rowData?.is_remark,
    });
    if (rowData.sub_master_values_details &&
      Array.isArray(rowData.sub_master_values_details) &&
      rowData.sub_master_values_details.length > 0) {
      rowData.sub_master_values_details.forEach((sub: any) => {
        this.subMasters.push(this.createSubMaster(sub));
      });
    }
  }

  saveMasterData(arg?: any) {
    if (!arg && this.masterForm.invalid) return;
    this.projectService.loading.set(true);
    const formValue = this.masterForm.getRawValue();
    const masterData = arg ? this.commonDataObject.selectedMaster : formValue;
    const payload = {
      master_type_name: masterData?.master_type_name?.master_type_id ? masterData?.master_type_name?.master_type_name : masterData?.master_type_name ? masterData?.master_type_name : null,
      master_type_key: masterData?.master_type_name?.master_type_id ? masterData?.master_type_name?.master_type_name : masterData?.master_type_name ? masterData?.master_type_name : null,
      master_type_id: arg ? this.commonDataObject?.selectedMaster?.master_type_id : (masterData?.master_type_name?.master_type_id ? masterData?.master_type_name?.master_type_id : null),
      master_value_id: arg ? this.commonDataObject?.selectedMaster?.master_value_id : (masterData?.master_type_name?.master_type_id && masterData?.master_value_id ? masterData?.master_value_id : (masterData?.master_type_name?.master_type_id && masterData?.master_value_id) ? formValue?.master_value_id : null),
      master_value_name: arg ? masterData?.master_value_name : formValue?.master_value_name,
      project_id: this.projectService.selectedProject()?.project_id,
      is_active: masterData?.is_active ?? false,
      is_remark: masterData?.is_remark ?? false,
      is_delete: arg ? true : false,
      sub_master_values_details: []
    };
    if (masterData?.sub_master_values_details && masterData?.sub_master_values_details.length > 0) {
      payload.sub_master_values_details = masterData?.sub_master_values_details.map((sub: any) => ({
        sub_master_value_id: sub.sub_master_value_id || null,
        sub_master_value_name: sub.sub_master_value_name,
        is_active: sub.is_active ?? true
      }));
    }
    this.clientService.postAPI(this.commonDataObject.APIObj.MASTER_UPSERT, payload).subscribe((res: any) => {
      if (res && res.code == 'CSR_MS_OK_200') {
        this.masterForm.reset();
        this.commonDataObject.apiMeassge = res.message;
        this.commonDataObject.issuccessAlert = true;
        this.getRowData();
      }
      else {
        this.commonDataObject.apiMeassge = res.message;
        this.commonDataObject.iserrorAlert = true;
      }
      this.commonDataObject.displayDialog = false;
      this.commonDataObject.deleteDialog = false;
      setTimeout(() => {
        this.projectService.loading.set(false);
        this.commonDataObject.issuccessAlert = false;
        this.commonDataObject.iserrorAlert = false;
      }, 1000);
    },
      (error) => {
        this.commonDataObject.displayDialog = false;
        this.commonDataObject.deleteDialog = false;
        this.commonDataObject.iserrorAlert = true;
        this.commonDataObject.apiMeassge = error.error.message;
        setTimeout(() => {
          this.projectService.loading.set(false);
          this.commonDataObject.issuccessAlert = false;
          this.commonDataObject.iserrorAlert = false;
        }, 1000);
      });
  }

  cancel() {
    this.commonDataObject.displayDialog = false;
    this.masterForm.reset();
  }
}